import React from 'react';
import { Desktop, Mobile } from '../../../../app-responsive';
import './forwarding-table.css';

const ForwardedEmailTable = (props) => {
  const {
    authorableContent,
    emailList,
  } = props;

  const {
    emailHeading,
    forwardedEmailHeading,
  } = authorableContent;

  const emailListContentDesktop = emailList.map(emailItem => (
    <div className="row email-row-item" key={emailItem.mailbox}>
      <div className="col-6">
        <div className="email-text">{emailItem.mailbox}</div>
      </div>
      <div className="col-6">
        <div className="email-text">{emailItem.forwardedMailbox}</div>
      </div>
    </div>
  ));

  const emailListContentMobile = emailList.map(emailItem => (
    <div className="row email-row-item" key={emailItem.mailbox}>
      <div className="col-12 mobile-heading">
        {emailHeading}
      </div>
      <div className="col-12 mobile-text">
        {emailItem.mailbox}
      </div>
      <div className="col-12 mobile-sub-heading">
        {forwardedEmailHeading}
      </div>
      <div className="col-12 mobile-sub-text">
        {emailItem.forwardedMailbox}
      </div>
    </div>
  ));

  return (
    <div className="forwarded-table-section">
      <Desktop>
        <div className="row">
          <div className="col-6 heading">
            {emailHeading}
          </div>
          <div className="col-6 heading">
            {forwardedEmailHeading}
          </div>
        </div>
        {emailListContentDesktop}
      </Desktop>
      <Mobile>
        {emailListContentMobile}
      </Mobile>
    </div>
  );
};

export default ForwardedEmailTable;

